import React from 'react';
import './Logo.css';

const Logo = ({ size = 'medium' }) => {
  return (
    <div className={`logo-container logo-${size}`}>
      <img 
        src="/tajabazzarlogo.png" 
        alt="Taja Bazzar Logo" 
        className="logo-image"
      />
    
    </div>
  );
};

export default Logo;

